'use strict'

import jwt from 'utils/jwt'
import { SESSION_HEADERS } from 'utils/constants'
import { groupUserClaims } from 'utils/claims/groupUserClaims'
import mockClaims from 'utils/claims/claimsList'

const token = JSON.parse(localStorage.getItem(SESSION_HEADERS))
let state = { claims: null }

if (token) {
  if (
    process.env.VUE_APP_API_URL === 'https://corporate.v3.staging.99taxis.com/webapi/v1/' ||
    process.env.VUE_APP_API_URL === 'https://empresas-v1.99app.com/webapi/v1/'
  ) {
    state = { claims: groupUserClaims(mockClaims.claims) }
  } else {
    // eslint-disable-next-line
    const { claims, ...noClaims } = jwt.decode(token.authorization)
    if (claims && noClaims && noClaims.business && noClaims.business.customClaims) {
      const customClaims = noClaims.business.customClaims
      state = { claims: groupUserClaims(claims.concat(customClaims)) }
    }
  }
}

const actions = {
  add ({ commit }, payload) {
    commit('add', groupUserClaims(payload))
  },

  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  add (state, payload) {
    state.claims = payload
  },

  clear (state) {
    state.claims = null
  }
}

const userClaims = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default userClaims
